import { render, staticRenderFns } from "./AppCategories.vue?vue&type=template&id=1d64e817&scoped=true&"
import script from "./AppCategories.vue?vue&type=script&lang=js&"
export * from "./AppCategories.vue?vue&type=script&lang=js&"
import style0 from "./AppCategories.vue?vue&type=style&index=0&id=1d64e817&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64e817",
  null
  
)

export default component.exports